export enum SvgIconName {
  StudioIcon = 'studio-icon',
  StudioIconHover = 'studio-icon-hover',

  RedDotIcon = 'red-dot-icon',
  MacCloseIcon = 'mac-close-icon',
  MacMinimizeIcon = 'mac-minimize-icon',
  MacFullScreenIcon = 'mac-full-screen-icon',
  MacCancelFullScreenIcon = 'mac-cancel-full-screen-icon',
  BackIcon = 'back-icon',
  BackIconBlueHover = 'back-icon-blue-hover',

  OrgIcon = 'org-icon',
  OrgIconHover = 'org-icon-hover',

  SettingIcon = 'setting-icon',
  SettingIconHover = 'setting-icon-hover',
  BillingIcon = 'billing-icon',
  BillingIconHover = 'billing-icon-hover',
  AuditHubIcon = 'audit-icon',
  AuditHubIconHover = 'audit-icon-hover',

  GameCardAddIcon = 'game-card-add-icon',

  InviteAddIcon = 'invite-add-icon',

  StudioNameEdit = 'studio-name-edit',
  Copy = 'copy',
  StudioDelete = 'studio-delete',

  'player-outline' = 'player-outline',
  'stats' = 'stats-outline',
  'service-battle' = 'service-battle',
  'matchmaking' = 'matchmaking',
  'hosting-outline' = 'hosting-outline',
  'custom-data' = 'custom-data',
  'auto-task' = 'auto-task',
  'leader-boards' = 'leader-boards',
  'text-chat' = 'text-chat',
  'add-ons' = 'add-ons',
  'dynamic-update' = 'dynamic-update',
  'grafana' = 'grafana',
  'health-monitor' = 'health-monitor',
  'launch-update' = 'launch-update',
  'privacy-access' = 'privacy-access',
  'audithub' = 'audithub',
  'notifications' = 'notifications',
  'microservice' = 'microservice',
  'game-items' = 'game-items',
  'store' = 'store',
  'mail' = 'mail',
  'commands' = 'commands',
  'gadgets' = 'gadgets',
  'friends' = 'friends',
  'voice' = 'voice',
  'remote-config' = 'remote-config',
  'guild' = 'guild',
  'all-product' = 'all-product',

  'Multiplayer' = 'Multiplayer',
  'Social' = 'Social',
  'Economy' = 'Economy',
  'Engagement' = 'Engagement',
  'Analytics' = 'Analytics',
}
